import { APIEntityType, FilterInterfaceFilter } from '@ardoq/api-types';
import {
  getOtherLabelsDataForReference,
  getIsShowReferenceTypeApplied,
} from './getOtherLabelsForReference';
import {
  getLabelsInterfaceWithModelInterfaces,
  LabelsInterface,
} from '../labelsInterface/labelsInterface';
import { formatOtherLabel } from './otherLabelUtils';
import { getOtherLabelsDataForComponent } from './getOtherLabelsForComponent';
import { getFirstFormattedMultiLabel } from './getFirstFormattedMultiLabel';
import { type I18nLocale } from '@ardoq/i18n';

type LabelFormattingParams = {
  modelId: string;
  entityLabel: string;
  entityType: APIEntityType;
  i18nLocale: I18nLocale;
  referenceLabelFilters: FilterInterfaceFilter[];
  labelsInterface?: LabelsInterface;
};

export const getLabelWithFormattingForViewsNotSupportingMultilabeling = ({
  modelId,
  entityLabel,
  entityType,
  i18nLocale,
  referenceLabelFilters,
  labelsInterface: argsLabelInterface,
}: LabelFormattingParams): string => {
  const isComponent = entityType === APIEntityType.COMPONENT;
  const labelsInterface =
    argsLabelInterface ?? getLabelsInterfaceWithModelInterfaces();

  const labelsData = isComponent
    ? getOtherLabelsDataForComponent(labelsInterface, modelId)
    : getOtherLabelsDataForReference(labelsInterface, modelId);
  if (!labelsData) {
    return entityLabel;
  }

  const firstRelevantLabelInfo = getFirstFormattedMultiLabel(
    labelsInterface,
    modelId,
    labelsData,
    entityType,
    i18nLocale
  );

  if (!firstRelevantLabelInfo) {
    const isShowReferenceTypeApplied = isComponent
      ? false
      : getIsShowReferenceTypeApplied(referenceLabelFilters);

    return !isComponent && isShowReferenceTypeApplied
      ? labelsData.entityTypeName
      : entityLabel;
  }

  const formattedLabel = `[${formatOtherLabel(firstRelevantLabelInfo)}]`;

  return `${entityLabel} ${formattedLabel}`;
};
